import { filterDeep } from 'deepdash-es/standalone';
import {
  NormalizedProjectTemplatePayload,
  denormalizePayload,
  setDynamicConditionInPayload,
  validatePhaseShiftInPayload,
} from 'data/templates/projects/api/transform';
import {
  ProjectTemplateApi,
  ProjectTemplateData,
} from 'data/templates/projects/types';
import {
  findLargestSumOfStartDayDuration,
  findLowestStartDay,
} from 'data/templates/projects/utils';

export const denormalizeAndCleanUpTemplate = (
  projectTemplate: NormalizedProjectTemplatePayload,
): ProjectTemplateApi => {
  const _template = setDynamicConditionInPayload(projectTemplate);
  const _phaseShiftValidTemplate = validatePhaseShiftInPayload(_template);
  const template = denormalizePayload(_phaseShiftValidTemplate);

  template.templateContent.projectPhases =
    filterDeep(
      template.templateContent.projectPhases,
      (object) => {
        if (object.isNew) {
          return false;
        }

        // eslint-disable-next-line no-param-reassign
        delete object.isNew;

        return true;
      },
      { childrenPath: ['tasks', 'subTasks'] },
    ) || [];

  const largestDuration = findLargestSumOfStartDayDuration(
    template.templateContent
      .projectPhases as unknown[] as ProjectTemplateData[],
  );
  const lowestStartDay = findLowestStartDay(
    template.templateContent
      .projectPhases as unknown[] as ProjectTemplateData[],
  );

  const total = largestDuration - lowestStartDay;

  template.templateContent.duration = total;
  template.templateContent.startDay = lowestStartDay;

  return template;
};
